import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const CrossmarkIcon = ({
  width = 24,
  height = 24,
  fill = '#52575C',
  stroke = '#52575C',
  additionalStyle,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    fill={fill}
    style={additionalStyle}
  >
    <path
      fillRule="evenodd"
      d="M6.94975 7.05025L16.8492 16.9497M6.94975 16.9497L16.8492 7.05025"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      clipRule="evenodd"
    />
  </svg>
);
